// src/views/admin/users/employees/view/tabs/AttendedTab.jsx
import React, { useEffect, useState } from 'react'
import Card from '@/components/ui/cards/Card'
import IsLoadingNotFound from '@/components/ui/tables/IsLoadingNotFound'
import ToastMe from '@/components/ui/ToastMe'
import { API_BASE_URL } from '@/constants/ApiConstant'

const API_BASE = API_BASE_URL

export default function AttendedTab({ employeeId }) {
  const [records, setRecords] = useState([])
  const [loading, setLoading] = useState(true)

  /** Build the Authorization header from localStorage */
  const authHdr = () => {
    const tok =
      localStorage.getItem('jwt_token')  ||
      localStorage.getItem('token')      ||
      localStorage.getItem('adminToken') ||
      ''
    return tok ? { Authorization: `Bearer ${tok}` } : {}
  }

  /** One fetch helper so we can call it twice */
  const fetchRows = async (withStatus = true) => {
    const qs = new URLSearchParams()
    qs.append('employee', employeeId)
    if (withStatus) qs.append('status', 'Present')

    const url = `${API_BASE}/attendance?${qs.toString()}`
    console.log('[AttendedTab] GET', url)

    const res  = await fetch(url, { headers: authHdr() })
    if (!res.ok) {
      ToastMe(`Server replied ${res.status}`, 'error')
      throw new Error(`HTTP ${res.status}`)
    }
    const json = await res.json()
    if (!json.success) {
      ToastMe(json.message || 'Query failed', 'error')
      throw new Error(json.message || 'Query failed')
    }
    return json.data || []
  }

  useEffect(() => {
    if (!employeeId) return           // nothing yet – wait for the page to load employee

    let cancelled = false
    ;(async () => {
      try {
        setLoading(true)
        let rows = await fetchRows(true)
        /* If there are zero “Present” rows, try again without status filter –
           helps to see whether the problem is the filter or genuinely no data */
        if (!cancelled && rows.length === 0) {
          console.info('[AttendedTab] 0 rows with status=Present, retrying unfiltered…')
          rows = await fetchRows(false)
        }
        if (!cancelled) setRecords(rows)
      } catch (err) {
        if (!cancelled) setRecords([])
        console.error('[AttendedTab] fetch error', err)
      } finally {
        if (!cancelled) setLoading(false)
      }
    })()
    return () => { cancelled = true }
  }, [employeeId])

  /* ---------- UI ---------- */
  if (loading)
    return <Card className="p-6 text-center">Loading attendance…</Card>

  if (!records.length)
    return (
      <Card className="p-6 text-center">
        No attendance data found for this employee.
      </Card>
    )

  return (
    <table className="w-full text-left border">
      <thead>
        <tr>
          <th className="p-2 border">Date</th>
          <th className="p-2 border">Check‑In</th>
          <th className="p-2 border">Check‑Out</th>
          <th className="p-2 border">Status</th>
        </tr>
      </thead>
      <tbody>
        {records.map(r => (
          <tr key={r._id} className="odd:bg-gray-50">
            <td className="p-2 border">
              {new Date(r.date).toLocaleDateString()}
            </td>
            <td className="p-2 border">
              {r.inTime
                ? new Date(r.inTime).toLocaleTimeString()
                : '—'}
            </td>
            <td className="p-2 border">
              {r.outTime
                ? new Date(r.outTime).toLocaleTimeString()
                : '—'}
            </td>
            <td className="p-2 border">{r.status}</td>
          </tr>
        ))}
      </tbody>
    </table>
  )
}
